import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import From from 'entities/mail_from'
import FromUpdateModal from './from_update_modal'
import FromDeleteModal from './from_delete_modal'

export default class FromListItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showUpdateModal: false,
      showDeleteModal: false
    }
  }

  showUpdateModal() {
    this.setState({
      showUpdateModal: true,
      showDeleteModal: false
    })
  }

  showDeleteModal() {
    this.setState({
      showUpdateModal: false,
      showDeleteModal: true
    })
  }

  hideModals() {
    this.setState({
      showUpdateModal: false,
      showDeleteModal: false
    })
  }

  handleClick(from) {
    const { onSelectFrom } = this.props

    this.hideModals()
    onSelectFrom(from)
  }

  handleUpdate(from) {
    const { onUpdateFrom } = this.props

    this.hideModals()
    onUpdateFrom(from)
  }

  handleDelete(from) {
    const { onDeleteFrom } = this.props

    this.hideModals()
    onDeleteFrom(from)
  }

  render() {
    const { from, updatable, deletable } = this.props
    const { showDeleteModal, showUpdateModal } = this.state
    const name = `${from.name} <${from.email}>`
    const fromName = from.confirmed ? (
      <button type="button" className="from-name" onClick={() => this.handleClick(from)}>
        {name}
      </button>
    ) : (
      <div className="from-name">
        {name}
        <div className="notice">{I18n.t('components.mail_from.from_list_item.message.confirm')}</div>
      </div>
    )

    const updateModal = updatable ? (
      <Fragment>
        <button type="button" className="btn btn-primary" onClick={() => this.showUpdateModal()}>
          {I18n.t('common.button.update')}
        </button>
        <FromUpdateModal
          from={from}
          show={showUpdateModal}
          onUpdate={newFrom => this.handleUpdate(newFrom)}
          onCancel={() => this.hideModals()}
        />
      </Fragment>
    ) : null

    const deleteModal = deletable ? (
      <Fragment>
        <button type="button" className="btn btn-delete" onClick={() => this.showDeleteModal()}>
          {I18n.t('common.button.delete')}
        </button>
        <FromDeleteModal
          from={from}
          show={showDeleteModal}
          onDelete={newFrom => this.handleDelete(newFrom)}
          onCancel={() => this.hideModals()}
        />
      </Fragment>
    ) : null

    const buttonGroup =
      updatable && deletable ? (
        <div className="btn-group">
          <div className="btn-group-in">
            {updateModal}
            {deleteModal}
          </div>
        </div>
      ) : null

    return (
      <div className="from-list-item">
        {fromName}
        {buttonGroup}
      </div>
    )
  }
}

FromListItem.propTypes = {
  from: PropTypes.instanceOf(From).isRequired,
  updatable: PropTypes.bool.isRequired,
  deletable: PropTypes.bool.isRequired,
  onSelectFrom: PropTypes.func.isRequired,
  onUpdateFrom: PropTypes.func.isRequired,
  onDeleteFrom: PropTypes.func.isRequired
}
